<template>
  <div class="dialogDetail">
    <div class="con" style="padding: 20px 55px">
      <div class="con-1">
        <p class="p"><i>题型模板：</i><span>{{formatterType('','',detailInfo.type)}}</span></p>
        <p class="p"><i>题目难度：</i><span>{{formatterLevel('','',detailInfo.level)}}</span></p>
        <p class="p"><i>课程目录：</i><span>{{detailInfo.directoryName}}</span></p>
        <p class="p"><i>关键字：</i><span>{{detailInfo.questionKey}}</span></p>
      </div>
      <div class="con-1">
        <p class="p"><i>适合专业：</i><span>{{detailInfo.professionName}}</span></p>
      </div>
    </div>
    <div class="con">
      <div><p class="p long"><i>题干：</i><span>{{detailInfo.content}}</span></p></div>
      <div style="overflow: hidden;padding-left: 78px;">
        <p class="p long">
          <div class="con-img" v-for="(v, index) in contentImage" :key="v.key" @click="openImageBox(contentImage,index)">
            <img :src="v.fileUrl" alt="">
          </div>
        </p>
      </div>
      <div v-for="(v, i) in options" :key="i">
        <p class="p long"><i>{{v.tab}}：</i><span>{{v.content}}</span><img v-if="v.key" :src="v.fileUrl" alt="" @click="openImageBox(v,i)"></p>
      </div>
      <div v-if="detailInfo.type!==5">
        <p class="p long"><i>正确答案：</i>
          <span v-if="detailInfo.type!==3">{{detailInfo.answer}}</span>
          <span v-else>{{detailInfo.answer==0?'正确':'错误'}}</span>
        </p>
      </div>
      <div v-else class="options" v-for="(v, i) in detailInfo.answer" :key="i">
        <p class="p long"><i>{{v.tab}}：</i><span>{{v.content}}</span></p>
      </div>
    </div>
    <div class="con">
      <div><p class="p long"><i>解析：</i><span>{{detailInfo.analysisContent}}</span></p></div>
      <div style="overflow: hidden;padding-left: 78px;">
        <p class="p long">
          <div class="con-img" v-for="(v, index) in analysisImg" :key="v.key" @click="openImageBox(analysisImg,index)">
            <img :src="v.fileUrl" alt="">
          </div>
        </p>
      </div>
    </div>
    <image-box ref="imageBox" style="z-index:3000"></image-box>
  </div>
</template>

<script>
import { questionServer } from '@/api/api'
import formatter from '@/mixin/formatter.js';
import imageBox from '@/components/imageBox';
export default {
  mixins: [formatter],
  components: {imageBox},
  data () {
    return {
      detailInfo: {},
      contentImage: [],
      analysisImg: [],
      options: []
    }
  },
  methods: {
    getDetail (id) {
      this.detailInfo = {}
      this.contentImage = [],
      this.analysisImg = [],
      this.options = []
      questionServer.questionDetail({
        id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.detailInfo = data
          this.detailInfo.options = JSON.parse(data.options)
          this.detailInfo.answer = data.type === 5 ? JSON.parse(data.answer) : data.answer
          this.getfileurl(data.contentImg, 'contentImage')
          this.getfileurl(data.analysisImg, 'analysisImg')
          this.getfileurl(this.detailInfo.options, 'options')
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    getfileurl (fileKeys, prop) {
      if (!fileKeys) {
        return
      }
      if (fileKeys.length) {
        if (Array.isArray(fileKeys)) {
          this[prop] = fileKeys.map(v => { return {...v, key: v.key}})
        } else {
          this[prop] = fileKeys.split(',').map(v => { return {key: v}})
        }
        this.$getUrl({
          fileKeys: Array.isArray(fileKeys) ? fileKeys.map(v => v.key).join() : fileKeys
        }).then(obj => {
          if (obj) {
            this[prop].forEach((e) => {
              if (e) {
                this.$set(e, 'fileUrl', obj[e.key] || '')
              }
            })
          }
        })
      }
    },
    // 查看图片
    openImageBox (list, index) {
      if (this.$refs.imageBox) {
        let imageList = []
        if (list.fileUrl) {
          imageList.push({ url: `${list.fileUrl}` })
        } else {
          for (let i = 0, length = list.length; i < length; i++) {
            imageList.push({ url: `${list[i].fileUrl}` })
          }
        }
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: list.fileUrl ? 0 : index // 问题区图片只有一张 下标传0
        })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.content {
  display: inline-block;
  width: 100%;
  text-align: left;
}
.img-box {
  text-align: left;
}
.con-img {
  width: 148px;
  height: 148px;
  float: left;
  margin-right: 10px;
  margin-bottom: 25px;
  overflow: hidden;
  img {
    width: 100%;
  }
}

span.label {
  font-weight: 600;
}
.option-item {
  text-align: left;
  img {
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }
}

// .dialogDetail {
//   position: relative;
// }
.con {
  background: #f5f6fa;
  margin-bottom: 20px;
  padding: 20px;
  text-align: left;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  .h1{
    color: #333;
    font-size: 15px;
    margin-bottom: 10px;
  }
  p {
    img {
      width: 30px;
      height: 30px;
    }
  }
  .yxlj-con{
    display: flex;
    position: relative;
    div{
      font-weight: normal;
    }
    label{
      position: absolute;
      left: 0;
    }
  }
  .con-1, .con-2{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    p {
      display: inline-block;
    }
  }
  .con-2{
    justify-content: start;
    .p{
      width: 30%;
    }
  }
  .p{
    display: flex;
    justify-content: start;
    i{
      display: inline-block;
    }
    span{
      display: inline-block;
    }
    .i-diy-width{
      width: 138px;
      /* text-align: right; */
    }
    .i-diy-width +span{
      width: calc(100% - 150px);
    }
  }
  .long{
    position: relative;
    padding-left: 78px;
    min-height: 22px;
    i{
      position: absolute;
      left: 0;
    }
  }
}
</style>
<style lang='scss'>
.form-detail-dialog {
  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label{
      font-weight: 600 !important;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/resource/details/questiondetail.vue